var map = {
	"./arts/arrow-doodle.svg": 8084,
	"./arts/boules.svg": 1481,
	"./arts/cabanedj.svg": 5349,
	"./arts/foodtruck.svg": 632,
	"./arts/lights.svg": 3464,
	"./arts/lightsbottom.svg": 7929,
	"./arts/lightstop.svg": 4321,
	"./arts/rivertree.svg": 8767,
	"./arts/sparkle.svg": 9779,
	"./arts/squiggle.svg": 202,
	"./arts/star4.svg": 7681,
	"./arts/treesideright.svg": 7200,
	"./brands/brooklyn.svg": 2941,
	"./brands/carlsberg.svg": 4918,
	"./brands/cocacola.svg": 9882,
	"./brands/fuzetea.svg": 7959,
	"./brands/redbull.svg": 4547,
	"./brands/sprite.svg": 5112,
	"./breakfast.svg": 3713,
	"./dj.svg": 7768,
	"./food.svg": 910,
	"./graphique.svg": 1298,
	"./graphiquebeige.svg": 3902,
	"./graphiquegris.svg": 5493,
	"./graphiquemarron.svg": 3215,
	"./graphiquered.svg": 5143,
	"./instacab.svg": 6876,
	"./instagram.svg": 1574,
	"./logocaliblack.svg": 1367,
	"./logocaliwhite.svg": 8298,
	"./logotop.svg": 716,
	"./magnifier.svg": 8458,
	"./openshare.svg": 8427,
	"./pattern.svg": 8264,
	"./phrases.svg": 300,
	"./sun.svg": 6868
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1980;